import React from 'react';
import { Container, Row, Col, InputGroup, Form, Button, Spinner } from 'react-bootstrap';

const DataTableFilters = ({
  searchText,
  onSearchChange,
  isSearching,
  searchPlaceholder,
  filterConfig,
  filters,
  onFilterChange,
  itemsPerPage,
  onItemsPerPageChange,
  onClearFilters, 
}) => {
  return (
    <Container fluid className="px-4 py-3">
      <Row className="g-2 align-items-end">
        <Col md={filterConfig.length > 0 ? 4 : 8}>
          <InputGroup>
            <Form.Control
              placeholder={searchPlaceholder}
              value={searchText}
              onChange={onSearchChange}
            />
            {isSearching && (
              <InputGroup.Text>
                <Spinner animation="border" size="sm" />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>

        {filterConfig.map(filter => (
          <Col md={2} key={filter.key}>
            <Form.Select
              value={filters[filter.key] || ''}
              onChange={(e) => onFilterChange(filter.key, e.target.value)}
            >
              <option value="">{filter.label}</option>
              {filter.options.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Form.Select>
          </Col>
        ))}

        <Col md={4}>
          <div className="d-flex gap-2">
            <Form.Select
              value={itemsPerPage}
              onChange={(e) => onItemsPerPageChange(parseInt(e.target.value))}
              style={{ minWidth: '140px' }}
            >
              <option value={10}>10 por página</option>
              <option value={20}>20 por página</option>
              <option value={50}>50 por página</option>
              <option value={100}>100 por página</option>
            </Form.Select>
            <Button
              variant="outline-secondary"
              className="flex-shrink-0"
              onClick={onClearFilters}
            >
              <i className="bi bi-eraser me-1"></i>
              Limpiar
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default React.memo(DataTableFilters);